import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { SharedModule, FormInputComponent, DateTimeCustomFieldConfig } from '@vendure/admin-ui/core';

@Component({
    template: `
        <vdr-datetime-picker
            class="disabled-date-time-form"
            [formControl]="formControl"
        ></vdr-datetime-picker>
    `,
    styleUrls: ['./disabled-date-time-form.component.scss'],
    standalone: true,
    imports: [SharedModule],
})
export class DisabledDateTimeFormComponent implements FormInputComponent<DateTimeCustomFieldConfig> {
    readonly: boolean;
    config: DateTimeCustomFieldConfig;
    formControl: FormControl;
}
